import React, { Component } from "react";
import Project from "./Project";
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>Check Out Some of My Works.</h1>
            <div
              id="portfolio-wrapper"
              className="bgrid-quarters s-bgrid-thirds cf"
            >
              {resumeData.portfolio &&
                resumeData.portfolio.map((item) => {
                  return (
                    <div className="columns portfolio-item">
                      <div
                        id={`project-popup-${item.id}`}
                        className="popup-modal"
                        style={{ display: "none" }}
                      >
                        <Project item={item} />
                      </div>

                      <div className="item-wrap">
                        <a
                          href={`#project-popup-${item.id}`}
                          onClick={() => {
                            var popup = document.getElementById(
                              `project-popup-${item.id}`
                            );
                            popup.style.display = "block";
                          }}
                        >
                          <img src={`${item.img1url}`} className="item-img" />
                          <div className="overlay">
                            <div className="portfolio-item-meta">
                              <h5>{item.name}</h5>
                              <p>{item.shortDescription}</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
